import { LANGS } from '@/layout/HomeLayout/components/Locale';
import { getStorage } from '@/utils/storage';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

interface ILngProps {
	[lng: string]: {
		translation: {
			[key: string]: unknown;
		};
	};
}
const cache: ILngProps = {};

function importAll(allFolder: __WebpackModuleApi.RequireContext) {
	allFolder.keys().forEach((folderKey: string) => {
		let lastPoint = folderKey.lastIndexOf('.');
		let lastLevel = folderKey.lastIndexOf('/');
		let firstLevel = folderKey.indexOf('/');
		let index = folderKey.substring(lastLevel + 1, lastPoint);
		let name = folderKey.substring(firstLevel + 1, lastLevel);
		cache[index] = { [name]: allFolder(folderKey).default, ...cache[index] };
	});

	const resource: ILngProps = {};
	for (let folder in cache) {
		resource[folder] = { translation: { ...cache[folder] } };
	}
	return resource;
}

// 获取文件夹
const getFolders = () => {
	return importAll(
		require.context(__dirname, true, /^(\.\/)([a-zA-Z0-9_-])+(\/)([a-zA-Z0-9]+)(\.ts)/),
	);
};

i18n.use(initReactI18next).init({
	lng: LANGS.find(item => item.key === getStorage('locale'))?.appApply,
	resources: getFolders(),
	fallbackLng: 'en'
});

export default i18n;
